// removed by extract-text-webpack-plugin
module.exports = {"fullWidth":"jc_f5","articleContainer":"jc_je","link":"jc_cx","imageContainer":"jc_cq","tile":"jc_jf","section":"jc_k","article":"jc_jg"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Masonry/styles.module.css
// module id = 1226
// module chunks = 27